import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

import GoogleMapController from "../../../../../../../src-js/Fratello/Map/Controllers/GoogleMapController";

export default function MapView(props) {
    const CollectionPointView = ComponentRegistry.get("CheckoutViewsCollectionPointView");

    return (
      <div>
        <GoogleMapController {...props} />
        {props.value ? <CollectionPointView {...props.value} /> : null}
      </div>
    );
}

MapView.propTypes = {
    value: PropTypes.shape({}),
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Checkout/Views/MapView.jsx